import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const ctfCommonMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    ctf: {
      shell: {
        title: "CTF 后台",
        portalEntry: "学员端",
        loginPageTitle: "{centerTitle}登录"
      },
      locale: {
        zhCN: "中文",
        en: "English",
        ja: "日本語"
      },
      menu: {
        dashboard: "总览",
        categories: "赛题分类",
        challenges: "赛题库",
        artifactReleases: "制品发布物"
      },
      labels: {
        category: "分类",
        challenge: "赛题",
        categoryId: "分类 ID",
        sourceUri: "来源 URI",
        contentDigest: "内容摘要",
        sourceNote: "来源备注",
        boundAt: "绑定时间",
        versionNo: "版本号",
        prompt: "题面",
        expectedFlag: "预期 Flag",
        artifactReleaseId: "制品发布物 ID",
      },
      values: {
        statuses: {
          active: "启用",
          archived: "已归档",
          draft: "草稿",
          ready: "可绑定",
          bound: "已绑定",
          published: "已发布"
        }
      },
      enumKinds: {
        categoryStatus: "分类状态",
        challengeStatus: "赛题状态",
        artifactStatus: "制品状态",
        versionStatus: "版本状态"
      },
      messages: {
        unknownEnumValue: "未知{kind}：{value}",
        undefinedEnumValue: "未定义{kind}",
        operationFailed: "操作失败"
      },
      placeholders: {
        searchCategoryName: "搜索分类名称",
        searchChallengeTitle: "搜索赛题标题",
        searchSourceUri: "搜索来源 URI",
        searchAuditActor: "搜索操作人"
      }
    }
  },
  en: {
    ctf: {
      shell: {
        title: "CTF Admin",
        portalEntry: "Learner Portal",
        loginPageTitle: "{centerTitle} Login"
      },
      locale: {
        zhCN: "中文",
        en: "English",
        ja: "日本語"
      },
      menu: {
        dashboard: "Dashboard",
        categories: "Categories",
        challenges: "Challenges",
        artifactReleases: "Artifact Releases"
      },
      labels: {
        category: "Category",
        challenge: "Challenge",
        categoryId: "Category ID",
        sourceUri: "Source URI",
        contentDigest: "Content digest",
        sourceNote: "Source note",
        boundAt: "Bound at",
        versionNo: "Version No.",
        prompt: "Prompt",
        expectedFlag: "Expected flag",
        artifactReleaseId: "Artifact release ID",
      },
      values: {
        statuses: {
          active: "Active",
          archived: "Archived",
          draft: "Draft",
          ready: "Ready",
          bound: "Bound",
          published: "Published"
        }
      },
      enumKinds: {
        categoryStatus: "category status",
        challengeStatus: "challenge status",
        artifactStatus: "artifact status",
        versionStatus: "version status"
      },
      messages: {
        unknownEnumValue: "Unknown {kind}: {value}",
        undefinedEnumValue: "Undefined {kind}",
        operationFailed: "Operation failed"
      },
      placeholders: {
        searchCategoryName: "Search category name",
        searchChallengeTitle: "Search challenge title",
        searchSourceUri: "Search source URI",
        searchAuditActor: "Search actor"
      }
    }
  },
  ja: {
    ctf: {
      shell: {
        title: "CTF 管理",
        portalEntry: "学習者ポータル",
        loginPageTitle: "{centerTitle}ログイン"
      },
      locale: {
        zhCN: "中文",
        en: "English",
        ja: "日本語"
      },
      menu: {
        dashboard: "概要",
        categories: "カテゴリ",
        challenges: "問題",
        artifactReleases: "成果物"
      },
      labels: {
        category: "カテゴリ",
        challenge: "問題",
        categoryId: "カテゴリ ID",
        sourceUri: "Source URI",
        contentDigest: "Content digest",
        sourceNote: "Source note",
        boundAt: "紐付け日時",
        versionNo: "バージョン番号",
        prompt: "問題文",
        expectedFlag: "期待 Flag",
        artifactReleaseId: "成果物 ID"
      },
      values: {
        statuses: {
          active: "有効",
          archived: "アーカイブ済み",
          draft: "草稿",
          ready: "紐付け可能",
          bound: "紐付け済み",
          published: "公開済み"
        }
      },
      enumKinds: {
        categoryStatus: "カテゴリ状態",
        challengeStatus: "問題状態",
        artifactStatus: "成果物状態",
        versionStatus: "バージョン状態"
      },
      messages: {
        unknownEnumValue: "未知の{kind}：{value}",
        undefinedEnumValue: "未定義の{kind}",
        operationFailed: "操作に失敗しました"
      },
      placeholders: {
        searchCategoryName: "カテゴリ名を検索",
        searchChallengeTitle: "問題タイトルを検索",
        searchSourceUri: "Source URI を検索",
        searchAuditActor: "操作ユーザーを検索"
      }
    }
  }
};
